<template>
    <section
            class="fibu-kontenblatt-list"
    >
        <b-card
            v-if="Object.keys(data).length"
            no-body
            class="row"
        >
            <b-tabs pills card vertical class="scroll">
                <b-tab
                        v-for="(entry, key) in data"
                        :key="key"
                        :title="key"
                        :active="key === activeKey"
                        @click="activeKey = key"
                        :title-link-class="!entry.buchungen.length ? 'empty-table' : null"
                >
                    <b-card-text>
                        <h2>
                            Kontenblatt für Konto: {{ key }}
                        </h2>
                        <Table
                            bordered
                            striped
                            small
                            showFilter
                            tableClass="mb-0"
                            :responsive="true"
                            :items="entry.buchungen"
                            :fields="fields"
                            :isBusy="busy"
                            busy-text="Lädt Kontenblätter..."
                            empty-text="Keine Buchungen - bei den ausgewählten Kriterien..."
                        >
                            <template v-slot:head(id)> ID<br />B-Nr.<br />Datum </template>

                            <template v-slot:head(konto)>
                                Finanzkonto<br />Buchungskonto<br />Verwendungszweck
                            </template>

                            <template v-slot:head(receiver)>
                                Mitglied (ID)<br />Empfänger/Absender
                            </template>

                            <template v-slot:head(sq)>
                                Sp_Mb<br>Sp_Gz<br>SpQ_gedr.
                            </template>

                            <template v-slot:id="{ row: row }">
                                <span
                                        :ref="'buchung' + String(row.item.id)"
                                        class="text-secondary"
                                >
                                    {{ row.item.id }}
                                </span>
                                <br />
                                {{ row.item.buchungsnr }}<br />
                                {{ $moment(row.item.datum).format("DD.MM.YYYY") }}
                            </template>


                            <template v-slot:konto="{ row: row }">
                                <template v-if="filter.type === 'finanzkonto'">
                                    {{ row.item.konto }}
                                    <br />
                                    {{ row.item.kontonr }} - {{ row.item.text }}
                                </template>
                                <template v-else>
                                    {{ row.item.kontonr }} - {{ row.item.text }}
                                    <br />
                                    {{ row.item.konto }}
                                </template>
                                <hr />
                                <span class="text-secondary">
                                    {{ row.item.verwendungszweck }}</span>
                            </template>

                            <template v-slot:receiver="{ row: row }">
                                {{ row.item.name }}, {{ row.item.vorname }} ({{ row.item.mitglied_id }})
                            </template>

                            <template v-slot:einnahmen="{ row: row }">
                                <template v-if="row.item.betrag && row.item.betrag >= 0">
                                    <span class="text-success">
                                        {{ currency(row.item.betrag) }}
                                    </span>
                                </template>
                                <template v-else>
                                    <span class="text-secondary">
                                        -
                                    </span>
                                </template>
                            </template>

                            <template v-slot:ausgaben="{ row: row }">
                                <template v-if="row.item.betrag && row.item.betrag < 0">
                                    <span class="text-danger">
                                        {{ currency(row.item.betrag) }}
                                    </span>
                                </template>
                                <template v-else>
                                    <span class="text-secondary">
                                        -
                                    </span>
                                </template>
                            </template>

                            <template v-slot:sq="{ row: row }">
                                <template v-if="!!Number(row.item.spendenquittung_mitgliedsbeitrag)">
                                    <span>X</span>
                                </template>
                                <template v-else>
                                    <span>-</span>
                                </template>
                                <br>
                                <template v-if="!!Number(row.item.Sq_Gz)">
                                    <span>X</span>
                                </template>
                                <template v-else>
                                    <span>-</span>
                                </template>
                                <br>
                                <template v-if="row.item.spendenquittung_gedruckt_id !== 0">
                                    <span
                                        class="print"
                                        @click="printSpendenquittung(row.item.id, row.item.spendenquittung_gedruckt_id)"
                                    >
                                        <font-awesome-icon icon="print"  size="lg" />
                                    </span>
                                </template>
                                <template v-else>
                                    <span>-</span>
                                </template>
                            </template>

                            <template v-slot:categories="{ row: row }">
                                <template v-if="!row.item.categories.length">
                                    <span>-</span>
                                </template>
                                <template v-else>
                                        <span
                                            v-for="(category, index) in row.item.categories"
                                            :key="index"
                                            class="categories"
                                        >
                                            {{ index === row.item.categories.length - 1 ? category : category + ',' }}
                                        </span>
                                </template>
                            </template>

                            <template v-slot:actions="{ row: row }">
                                <b-button

                                    :size="size"
                                    variant="link"
                                    class="mv-table-action-btn mr-1"
                                    @click="dataEdit(row, key)"
                                    :disabled="row.written_to_jahresabschluss !== null"
                                >
                                    Bearbeiten
                                </b-button>
                                <b-button

                                    :size="size"
                                    @click="dataDelete(row)"
                                    variant="link"
                                    class="text-danger mv-table-action-btn"
                                    :disabled="row.written_to_jahresabschluss !== null"
                                >
                                    Löschen
                                </b-button>
                            </template>

                            <template v-slot:custom-foot="{ data }">
                                <b-tr>
                                    <b-td colspan="3">
                                        Summen für {{ key }}
                                    </b-td>
                                    <b-td
                                        class="text-right"
                                        v-html="currencyColored(
                                            entry.buchungen.reduce((acc, curr) => {
                                                if(parseFloat(curr.betrag) > 0) {
                                                    return acc + parseFloat(curr.betrag);
                                                } else {
                                                    return acc + 0;
                                                }
                                            }, 0)
                                        )"
                                    >
                                    </b-td>
                                    <b-td
                                        class="text-right"
                                        v-html="currencyColored(
                                            entry.buchungen.reduce((acc, curr) => {
                                                if(parseFloat(curr.betrag) < 0) {
                                                    return acc + parseFloat(curr.betrag);
                                                } else {
                                                    return acc + 0;
                                                }
                                            }, 0)
                                        )"
                                    >

                                    </b-td>
                                    <b-td colspan="3">

                                    </b-td>
                                </b-tr>
                            </template>
                        </Table>
                        <p>Sp_Mb: Spende Mitgliedsbeitrag, Sp_Gz: Spende Geldzuwendung, Sp_gedr.: Spendenquittung gedruckt</p>
                        <p
                            v-if="entry.buchungen.length"
                        >
                            Gesamtsumme (Einnahmen und Ausgaben) über alle Jahre:
                            <span
                                    v-html="currencyColored(entry.sumsAllYears)"
                            >
                            </span>
                        </p>
                        <FiBuKontenblaetterSums
                            v-if="activeKey === key"
                            :entry="entry"
                        />
                    </b-card-text>
                </b-tab>
                <RemoveModal
                    :title="selected.title"
                    :busy="selected.busy"
                    @ok="dataProvide"
                    @hide="dataHide"
                />
            </b-tabs>
        </b-card>
    </section>

</template>

<script>
import Size from "@/mixins/Size/Size";
import { ApiFactory } from "@/api/ApiFactory";
import Table from "@/components/Table/Table.vue";
import Currency from "@/mixins/Currency/Currency";
import { BlobUtil } from "@/utils/BlobUtil";
import CommonView from "@/mixins/CommonView/CommonView";
import RemoveModal from "@/components/RemoveModal/RemoveModal.vue";
import './FiBuBuchungsblaetterList.scss';
import FiBuKontenblaetterSums from "@/components/FiBuKontenblaetterSums/FiBuKontenblaetterSums.vue";

const FiBuKontenblaetterApi = ApiFactory.get('fibuKontenblaetterApi');
const SpendenquittungApi = ApiFactory.get('fibuSpendenquittung');
const FiBuBuchungsApi = ApiFactory.get('fibuBuchung');

    export default {
        name: 'KontenblaetterList',
        props: ['finanzkonto', 'buchungskonto', 'category', 'data', 'filter'],
        mixins: [Size, Currency, CommonView],
        components: {
            FiBuKontenblaetterSums,
            RemoveModal,
            Table
        },
        data() {
            return {
                api: FiBuBuchungsApi,
                prefetch: false,
                busy: false,
                activeKey: '',
                fields: [
                    {
                        key: "id",
                        label: "ID",
                        sortable: true,
                        class: "text-center"
                    },
                    {
                        key: "konto",
                        label: "Konto",
                        sortable: true
                    },
                    {
                        key: "receiver",
                        label: "Empfänger",
                        sortable: true
                    },
                    {
                        key: "einnahmen",
                        label: "Einnahmen",
                        sortable: true,
                        class: "text-right"
                    },
                    {
                        key: "ausgaben",
                        label: "Ausgaben",
                        sortable: true,
                        class: "text-right"
                    },
                    {
                        key: "sq",
                        label: "Spendenquittung",
                        sortable: true,
                        class: "text-center"
                    },
                    {
                        key: "categories",
                        label: "Kategorien",
                        sortable: true
                    },
                    {
                        key: "actions",
                        label: "Funktionen",
                        class: "text-center",
                    }
                ],
            }
        },

        methods: {
            async printSpendenquittung(id, spId) {
                this.busy = true;

                const response = await SpendenquittungApi.getSingle(id, spId);

                if(response.ok) {
                    BlobUtil.openBlob(response.blob);
                }

                this.busy = false;
            },
            dataEdit(data, key) {
                this.$store.dispatch("pages", {
                    fibu_kontenblaetter: {
                        buchung: data.id,
                        key: key,
                        editBuchung: true
                    }
                });

                this.$router.push({
                    path: "/fibu/buchung/" + data.id
                })
            },
            delete(evt) {
              this.dataProvide(evt);


            },
            scrollToAnchorPoint(refName) {
                const el = this.$refs['buchung'+ refName][0];
                el.scrollIntoView({behavior: 'smooth', block: 'center'});
            },
            postProcessRemove(selectedItem, response) {
                this.$emit('buchungDeleted', selectedItem);
            },
        },
        watch: {
            data(val) {
                if(Object.keys(val).length === 0) {
                    return;
                }
                const pages = this.$store.getters.getPages;

                if(pages.fibu_kontenblaetter.key) {
                    this.activeKey = pages.fibu_kontenblaetter.key;
                    pages.fibu_kontenblaetter.key = null;

                    let itemToScroll = pages.fibu_kontenblaetter.buchung;
                    this.$nextTick(() => this.scrollToAnchorPoint(itemToScroll));
                    this.$store.dispatch("pages", {
                        fibu_kontenblaetter: {
                            buchung: null
                        }
                    });
                }
            }
        }
    }
</script>